import {FETCH_ABOUT_REQUEST, FETCH_ABOUT_SUCCES, FETCH_ABOUT_ERROR} from '../constants/About'

const initialState = {
  item: {},
  hasErrored: false,
  isLoading: false
}

export default function about(state = initialState, action) {
  switch (action.type) {
    case FETCH_ABOUT_REQUEST:
      return {...state, isLoading: true};
    case FETCH_ABOUT_SUCCES:
      return {...state, item: action.payload, isLoading: false};
    case FETCH_ABOUT_ERROR:
      return {...state, hasErrored: true, isLoading: false};
    default:
        return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/about.js